import { RoundTripCyclePicker, type PlaybackCycle } from './RoundTripCycles'

/** TRIPS tab body. Replay is always a whole round trip: it starts when the truck leaves
 *  Dhar and, until the truck is back in Dhar, runs live up to now. (Single hub-to-hub leg
 *  replay was removed on request, 2026-11-03 -- a leg is a fragment of the trip ops track.) */
export function ReplayTripsPanel({
  activeId, onPickCycle, layout = 'list',
}: {
  activeId?: string | null
  onPickCycle: (c: PlaybackCycle) => void
  layout?: 'list' | 'grid'
}): JSX.Element {
  return (
    <div className={layout === 'grid' ? 'flex flex-col gap-3' : 'flex min-h-0 flex-1 flex-col gap-2'}>
      <RoundTripCyclePicker activeId={activeId} onPick={onPickCycle} layout={layout} />
    </div>
  )
}
